import { Router, NavigationCancel } from '@angular/router';
import { getAuthorizeToken, User, UserSession, IKnowAuthorization, SessionEventNotificationService } from '@westjetairlines/wjesd-oauth2-library';
import { Component, OnInit, Inject, forwardRef } from '@angular/core';
import { SpinnerComponent as Spinner } from "@westjetairlines/wjesd-component-library";

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})

export class LoginComponent implements OnInit {
  isAuthenticated: boolean;
  user: User;

  constructor(@Inject(forwardRef(() => getAuthorizeToken)) private authService: IKnowAuthorization, private router: Router,
              private sessionEventNotificationService: SessionEventNotificationService) {

    this.router.events.subscribe(event => {
        if (event instanceof NavigationCancel) {
            if (authService.isAuthResponse(event.url)) {
              this.router.navigate(['/']);
            }
        }
    });
  }

  ngOnInit() {
    Spinner.start();
    let self = this;
    this.authService.validateSession(null).subscribe((session: UserSession) => {
        self.isAuthenticated = session.isValid;
        if (session.isValid) {
          self.user = session.user;
          console.log('session validated');
          self.sessionEventNotificationService.initialize();
        }
        else {
          console.log('session validation failed');
        }
        Spinner.stop();
      },
      err => {
        console.error(err);
        Spinner.stop();
      },
      () => {
        console.log('validation complete');
      });
  }

  logIn() {
    localStorage.setItem('renew_count', '0');
    this.authService.logIn();
  }

  logOut() {
    localStorage.removeItem('renew_count');
    this.authService.logOut();
  }
}



// WEBPACK FOOTER //
// ./src/app/layout/login/login.component.ts